import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-rest-days',
  templateUrl: './rest-days.component.html',
  styleUrls: ['./rest-days.component.scss'],
})
export class RestDaysComponent implements OnInit {
  @ViewChild('deleteModalVacations', { static: false })
  deleteModalVacations!: TemplateRef<any>;
  deleteModalClose: any;
  breadcrumbs: any;
  paramId: string | null = '';
  employeeName: string = '';
  deletedId: Number = 0;
  message: string = '';
  page: number = 1;
  infoVacations: any = [];
  flagDeleted: boolean = false;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private modal: NgbModal
  ) {}

  ngOnInit(): void {
    this.paramId = this.route.snapshot.paramMap.get('id');
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de colaboradores',
        path: '/employees/list',
        link: true,
      },
      {
        name: 'Vacaciones del colaborador',
        link: false,
      },
    ];

    this.getInfo();
  }

  getInfo() {
    this.api.getById('employee/vacations', Number(this.paramId)).subscribe({
      next: (info) => {
        this.employeeName = info.information.name;
        this.infoVacations = info.information.vacations;
      },
      error: (err) => {},
    });
  }

  openDeleteVacation(id: Number): void {
    this.deletedId = id;

    this.deleteModalClose = this.modal.open(this.deleteModalVacations, {
      size: 'md',
    });
  }

  close(): void {
    this.deletedId = 0;
    this.deleteModalClose.close();
  }

  deleteVacation(id: Number): void {
    this.api.delete('employee/vacations', Number(id)).subscribe({
      next: (data) => {
        this.message = data.message;
        this.flagDeleted = true;
        this.close();

        setTimeout(() => {
          this.flagDeleted = false;
          this.message = '';
          this.getInfo();
        }, 3000);
      },
      error: (err) => {},
    });
  }
}
